'use client'

import './error.scss'
import ErrorPage from "@/partials/ErrorPage"

export default function Error(props) {

  return <ErrorPage {...props}></ErrorPage>

}